import {IReduxWorkdayState} from '@src/@interfaces';

export const state: IReduxWorkdayState = {
    started_at: null,
    finished_at: null,
    breaks: [],
    currentBreak: null,
};
